export const AIS3_MAIN_PAGE_ENTITY_NAME = 'ais3.dashboard';
